import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeft, Layers } from 'lucide-react';
import { fetchInstructorBatches, InstructorBatch } from '../../_services/academic.service';
import { SkeletonLoader } from '../../_components/skeleton-loader';
import './_director-dashboard.css';

const InstructorBatches: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [batches, setBatches] = useState<InstructorBatch[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadBatches = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchInstructorBatches();
        setBatches(response.data || []);
      } catch (err) {
        console.error('Error loading instructor batches:', err);
        setError('Failed to load batches. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    loadBatches();
  }, []);

  const handleBatchClick = (batchId: number) => {
    history.push(`/director-dashboard/batch/${batchId}`, { from: 'instructor-batches' });
  };

  if (loading) {
    return <SkeletonLoader type="dashboard" />;
  }

  return (
    <div className="director-dashboard">
      <div className="breadcrumb">
        <button onClick={() => history.push('/home')}>
          <ArrowLeft size={20} />
          Back to Home
        </button>
      </div>

      <div className="director-header">
        <div className="director-title">
          <Layers size={32} />
          <div>
            <h1>Batch Analysis</h1>
            <p>Your assigned batches</p>
          </div>
        </div>
      </div>

      {error && (
        <div style={{ padding: '16px', background: 'var(--status-danger-bg)', borderRadius: '8px', color: 'var(--status-danger)', marginBottom: '20px' }}>
          {error}
        </div>
      )}

      <div className="batches-section">
        <h2>
          <Layers size={24} />
          Batches ({batches.length})
        </h2>
        <div className="batches-grid">
          {batches.map((batch) => (
            <div
              key={batch.batchId}
              className="batch-card"
              onClick={() => handleBatchClick(batch.batchId)}
            >
              <div className="batch-card-header">
                <div className="batch-title">
                  <h4>{batch.batchName}</h4>
                  <span className="batch-code">{batch.batchCode}</span>
                </div>
              </div>
              <div className="batch-card-footer">
                <span className="view-batch">View Batch →</span>
              </div>
            </div>
          ))}
        </div>

        {batches.length === 0 && !error && (
          <div className="no-results">
            <p>No batches assigned to you</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstructorBatches;
